import { TextComponentContent } from '../../../types/elearning';
import { sanitizeElearningHtml } from '../../../utils/elearningHtml';

interface TextBlockViewerProps {
  content: TextComponentContent;
}

export default function TextBlockViewer({ content }: TextBlockViewerProps) {
  const sanitizedHtml = sanitizeElearningHtml(content.html);

  return (
    <div
      className="prose prose-sm max-w-none text-gray-700"
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}

